import { render, staticRenderFns } from "./MetricsCard.vue?vue&type=template&id=c3d63568&scoped=true&"
import script from "./MetricsCard.vue?vue&type=script&lang=js&"
export * from "./MetricsCard.vue?vue&type=script&lang=js&"
import style0 from "./MetricsCard.vue?vue&type=style&index=0&id=c3d63568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d63568",
  null
  
)

export default component.exports